import { render, staticRenderFns } from "./fullcalendar.vue?vue&type=template&id=63e0ca09&scoped=true"
import script from "./fullcalendar.vue?vue&type=script&lang=js"
export * from "./fullcalendar.vue?vue&type=script&lang=js"
import style0 from "./fullcalendar.vue?vue&type=style&index=0&id=63e0ca09&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0ca09",
  null
  
)

export default component.exports